module.exports = __webpack_public_path__ + "img/北京地铁资源深色背景.ab69808e.png";